module.exports = __webpack_public_path__ + "static/media/Step 2-Import_pdf.2c22d65a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 2-Import_pdf.gif
// module id = 3043
// module chunks = 0